import React from "react";
import { useNavigate } from "react-router-dom"

import "./Footer.scss";
import { BsInstagram } from 'react-icons/bs';
import { FaTwitter } from 'react-icons/fa';
import { ImYoutube } from 'react-icons/im';
import { BsFacebook } from 'react-icons/bs';





const Footer = () => {
  const Navigate = useNavigate()

  const goToTop = () => {
    window.scrollTo(0, 0);
  }

  return (
    <>
      <div className="footer_container">
        <div className="footer_main">
          <div className="footer_content">
            <div className="part_1">
              <p className="title" onClick={() => Navigate("/")}>Flux Technologies</p>

              {/* <div className="menu_text">Discover Air</div> */}

              <div className="menu_text" onClick={goToTop}>Design Yours</div>

              <div className="menu_text" onClick={() => Navigate("/store")}>Store</div>
            </div>
            <div className="part_1">
              <p className="title">Flux Motors</p>

              {/* <div className="menu_text">Company</div> */}

              {/* <div className="menu_text">Leadership</div> */}

              {/* <div className="menu_text">Careers</div> */}

              <div className="menu_text" onClick={()=>Navigate("/about")}>About</div>

              {/* <div className="menu_text">Tech Talks</div> */}

              {/* <div className="menu_text">Future Models</div> */}

              <div className="menu_text" onClick={() => Navigate("/subscribe")}>Stay Update</div>
            </div>
            <div className="part_1">
              <p className="title">More</p>

              {/* <div className="menu_text">Purchase &amp; Ownership</div> */}

              {/* <div className="menu_text">Payment Calculator</div> */}

              {/* <div className="menu_text">FAQ</div> */}

              <div className="menu_text" onClick={() => Navigate("/contact")}>Contact Us</div>

              <div className="menu_text" onClick={() => Navigate("/privacy")}>Privacy Policy</div>

              {/* <div className="menu_text">Terms of Use</div> */}

              {/* <div className="menu_text">Code of Conduct</div> */}

              {/* <div className="menu_text">Warranty</div> */}
            </div>
          </div>

          <div className="footer_link">
            <div className="switch_language">
              <img
                className="globe"
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iI0ZGRkZGRiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iNy41IiBzdHJva2U9IiMxQjFCMUIiLz4KPHBhdGggZD0iTTE4IDdDMTYuNDI1MyA3LjYyMDYgMTQuMzE2OSA4IDEyIDhDOS42ODMxMiA4IDcuNTc0NzMgNy42MjA2IDYgNyIgc3Ryb2tlPSIjMUIxQjFCIi8+CjxwYXRoIGQ9Ik0xOCAxN0MxNi40MjUzIDE2LjM3OTQgMTQuMzE2OSAxNiAxMiAxNkM5LjY4MzEyIDE2IDcuNTc0NzMgMTYuMzc5NCA2IDE3IiBzdHJva2U9IiMxQjFCMUIiLz4KPHBhdGggZD0iTTE1LjUgMTJDMTUuNSAxNC4xNDgzIDE1LjA2MzUgMTYuMDY4NiAxNC4zODEyIDE3LjQzMzJDMTMuNjgzOSAxOC44Mjc4IDEyLjgxMzIgMTkuNSAxMiAxOS41QzExLjE4NjggMTkuNSAxMC4zMTYxIDE4LjgyNzggOS42MTg3OSAxNy40MzMyQzguOTM2NDYgMTYuMDY4NiA4LjUgMTQuMTQ4MyA4LjUgMTJDOC41IDkuODUxNjUgOC45MzY0NiA3LjkzMTQxIDkuNjE4NzkgNi41NjY3NUMxMC4zMTYxIDUuMTcyMTkgMTEuMTg2OCA0LjUgMTIgNC41QzEyLjgxMzIgNC41IDEzLjY4MzkgNS4xNzIxOSAxNC4zODEyIDYuNTY2NzVDMTUuMDYzNSA3LjkzMTQxIDE1LjUgOS44NTE2NSAxNS41IDEyWiIgc3Ryb2tlPSIjMUIxQjFCIi8+CjxsaW5lIHgxPSI0IiB5MT0iMTIiIHgyPSIyMCIgeTI9IjEyIiBzdHJva2U9IiMxQjFCMUIiLz4KPGxpbmUgeDE9IjEyIiB5MT0iMjAiIHgyPSIxMiIgeTI9IjQiIHN0cm9rZT0iIzFCMUIxQiIvPgo8L3N2Zz4K"
                alt="Globe Icon"
              />
              <p>
                United States – English
              </p>
              {/* <select
                id="footer-lang-selector"
                className="SwitchLanguageComponent-module--select--jkCrt SwitchLanguageComponent-module--enSelect--NvjoL"
              >
                <option value="en" selected>
                </option>
                <option value="en-ca">Canada – English</option>
                <option value="fr-ca">Canada – Français</option>
                <option value="de-de">Deutschland - Deutsch</option>
                <option value="nl-nl">Nederland - Nederlands</option>
                <option value="de-ch">Schweiz - Deutsch</option>
                <option value="fr-ch">Suisse - Français</option>
                <option value="nb-no">Norge - Norsk</option>
                <option value="ar-sa">
                  المملكة العربية السعودية – العربية
                </option>
              </select> */}
            </div>

            <div className="social_link">
              <div className="links">

                <BsInstagram className="icons" />

                <FaTwitter className="icons" />

                <ImYoutube className="icons" />

                <BsFacebook className="icons" />

              </div>
            </div>

            <div className="legal" style={{ cursor: "pointer" }} onClick={() => Navigate("/terms")}>Legal</div>

            <div className="copyright">©2022 Flux. All rights reserved</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
